/**
 * theme.ts — Widget theme shape mirrored from API.
 *
 * This is a hand-mirrored subset of
 * `apps/api/src/dashboard/widget-theme.ts`. The widget bundle cannot
 * import zod (bloat), so we duplicate the type and provide a simple
 * applier function instead of validation.
 *
 * Keep these in sync when the API schema changes.
 */

export type WidgetPosition = 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left'

/** Greeting-card copy. Every field optional — see widgetTeaserSchema. */
export interface WidgetTeaser {
  greeting?: string
  questions?: string[]
  delayMs?: number
  autoHideMs?: number
  enabled?: boolean
}

export interface WidgetTheme {
  primary: string
  accent: string
  position: WidgetPosition
  radius: number
  title?: string
  bubbleAvatarUrl?: string
  panelAvatarUrl?: string
  teaser?: WidgetTeaser
}

export const DEFAULT_THEME: WidgetTheme = {
  primary: '#1f6feb',
  accent: '#ffffff',
  position: 'bottom-right',
  radius: 12,
}

/**
 * Apply positioning to the host container based on theme.position.
 * Returns a CSS string suitable for `host.style.cssText`.
 */
export function applyPosition(position: WidgetPosition): string {
  const base = 'position:fixed;z-index:2147483647;'
  switch (position) {
    case 'bottom-right':
      return base + 'bottom:20px;right:20px;'
    case 'bottom-left':
      return base + 'bottom:20px;left:20px;'
    case 'top-right':
      return base + 'top:20px;right:20px;'
    case 'top-left':
      return base + 'top:20px;left:20px;'
  }
}
